import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { ContentId } from 'src/utils/constants/contentId';

export const LaunchBulkWasteTickets = ({
  onClick,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  return (
    <PosDropdownItem
      key="WasteTicketsItem"
      onClick={onClick}
      disabled={disabled}
    >
      <Content id={ContentId.WasteTickets} />
    </PosDropdownItem>
  );
};
